import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import 'bootstrap/dist/css/bootstrap.min.css';
import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';
// import * as smoothscroll from 'smoothscroll-polyfill';
// smoothscroll.polyfill()

// window.__forceSmoothScrollPolyfill__ = true;

// Initialize PostHog
posthog.init(process.env.REACT_APP_POSTHOG_KEY, {
  api_host: process.env.REACT_APP_POSTHOG_HOST,
  person_profiles: 'identified_only',
});

ReactDOM.render(
  <PostHogProvider client={posthog}>
    <App />
  </PostHogProvider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
